import IconMeta from 'assets/icon-meta.svg?react'
import IconGoogleAds from 'assets/icon-google-ads.svg?react'
import IconAudienceNetwork from 'assets/icon-audience-network.svg?react'
import IconInstagram from 'assets/icon-instagram.svg?react'
import IconSnapchat from 'assets/icon-snapchat.svg?react'
import IconTiktok from 'assets/icon-tiktok.svg?react'
import IconYoutube from 'assets/icon-youtube.svg?react'
import IconAdsens from 'assets/icon-adsens.svg?react'

const CREATIVE_CHANNEL: Record<number, string> = {
  2: 'FB News Feed',
  39: 'Instagram',
  3: 'Audience Network',
  55: 'Ad Sense',
  1: 'Google Ads(Admob)',
  // 51: 'Messenger',
  6: 'YouTube',
  // 10: 'Twitter',
  // 5: 'UnityAds',
  // 19: 'Vungle',
  // 20: 'AppLovin',
  // 24: 'AdColony',
  // 25: 'Chartboost',
  // 40: 'Pinterest',
  // 42: 'ironSource',
  // 23: 'Yahoo!',
  // 44: 'reddit',
  43: 'TikTok',
  // 45: 'TopBuzz',
  // 46: 'Mintegral (Mobvista)',
  // 310: 'Pangle(TikTok Audience Network)',
  52: 'Snapchat',
  // 49: 'MoPub',
  // 47: 'Tapjoy',
  // 57: 'Kwai',
  // 27: 'NAVER(네이버)',
  // 26: 'Daum(다음)',
  // 34: 'Nate(네이트)',
  // 28: 'Ameba(アメーバ)',
  // 36: 'Yahoo! Japan',
  // 301: 'Gunosy(グノシー)',
  // 303: 'Zucks',
  // 300: 'SmartNews(スマートニュース)',
  // 304: 'i-mobile',
  // 305: 'AkaNe',
  // 307: 'Nend',
  // 308: 'AMoAd',
};

const useCreativeChannelIcon = (id: number) => {
  const getChannelIcon = ()=> {
    if(id === 1) return IconGoogleAds
    if(id === 2) return IconMeta
    if(id === 3) return IconAudienceNetwork
    if(id === 6) return IconYoutube
    if(id === 39) return IconInstagram
    if(id === 43) return IconTiktok
    if(id === 52) return IconSnapchat
    if(id === 55) return IconAdsens

    return IconMeta
  }

  const channelName =  CREATIVE_CHANNEL[id]

  return {
    ChannelIcon: getChannelIcon(),
    channelName,
  }
}

export default useCreativeChannelIcon;
